(() => {
  function init(root = document) {
    const track = root.querySelector('#pastel-products');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = 'true';
    const prev = root.querySelector('[data-pastel-prev]');
    const next = root.querySelector('[data-pastel-next]');
    const update = () => { prev.disabled = track.scrollLeft < 5; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5; };
    const move = direction => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive: true}); new ResizeObserver(update).observe(track); update();
  }
  init(); document.addEventListener('shopify:section:load', () => init());
})();